import React from 'react'
import Carousel from './Carousel'



const CardProduct = ({title,  videoAccueil, description, playlistLink,free}) => {
  return (
    <div className="md:w-1/2 md:mx-auto mt-20 w-4/5 mx-auto ">
    <div>
      <a href='/'>Ousmane learning</a>
    </div>

    <div className="card bg-base-100 shadow-xs mt-2 ">
    <h3 className="card-title  mb-2 ">{title}</h3>
      <figure>
      
            <iframe
            title={videoAccueil}
            className='rounded-xl'
                width="95%"
                height="400"
                autoplay={0}
                src={`https://www.youtube.com/embed/${videoAccueil}?autoplay=1`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                ></iframe>
      </figure>
      <div className="card-body border-b-[1px] pb-14">
       
        
        <div>
          <Carousel />
        </div>
        <div className="card-actions justify-end ">
         
  
        
        <a href={"https://wa.me/237699044427?text=je veux votre formation "+title.toLowerCase()}  rel="noreferrer" target="_blank" className="btn btn-error btn-xs sm:btn-sm md:btn-md lg:btn-l">Achèter</a>
        <a href={playlistLink}  target='_blank' rel="noreferrer" className="btn  btn-neutral btn-xs sm:btn-sm md:btn-md lg:btn-l">Voir les {free} vidéos gratuites</a>
        </div>
        <p className='mt-4'>{description}</p>
      </div>
    </div>

  </div>
  )
}

export default CardProduct
